import { Accordion, AccordionContent, AccordionItem } from 'ui/components/AccordionV3/Accordion';
import { Info } from 'ui/icons/icons/Toast/info';
import clsx from 'clsx';
import { useMemo } from 'react';
interface FeatureAvailabilityDisclaimerProps {
  disclaimerText: string;
  isOpen?: boolean;
  hideForMobile?: boolean;
  hideForDesktop?: boolean;
}
export function FeatureAvailabilityDisclaimer({
  disclaimerText,
  isOpen,
  hideForMobile,
  hideForDesktop
}: FeatureAvailabilityDisclaimerProps) {
  const mobileStyles = () => {
    if (isOpen) {
      return hideForMobile ? 'hidden' : 'flex';
    } else return 'hidden';
  };
  const getDesktopStyles = () => {
    if (isOpen) {
      return hideForDesktop ? 'md:hidden' : 'md:flex';
    } else return 'hidden';
  };
  return <div data-testid='feature-availability-disclaimer' className={clsx(mobileStyles(), getDesktopStyles())} data-sentry-component="FeatureAvailabilityDisclaimer" data-sentry-source-file="FeatureAvailabilityDisclaimer.tsx">
      <Accordion type='single' collapsible value={isOpen ? 'disclaimer-item' : ''} className={'w-full'} data-sentry-element="Accordion" data-sentry-source-file="FeatureAvailabilityDisclaimer.tsx">
        <AccordionItem value='disclaimer-item' data-sentry-element="AccordionItem" data-sentry-source-file="FeatureAvailabilityDisclaimer.tsx">
          <AccordionContent data-sentry-element="AccordionContent" data-sentry-source-file="FeatureAvailabilityDisclaimer.tsx">
            <div className='mx-auto -mb-3 flex w-[304px] items-center rounded-2xl bg-gray-400 p-4 md:w-auto md:max-w-[1008px]'>
              <div className='mr-4'>
                <Info color='black' width={26} height={26} data-sentry-element="Info" data-sentry-source-file="FeatureAvailabilityDisclaimer.tsx" />
              </div>
              <p className='text-left'>{disclaimerText}</p>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>;
}